export default "__VITE_ASSET__CQx3kHRw__"